module.exports = __webpack_public_path__ + "img/person-selected.f75eb4a6.svg";